import { motion } from 'framer-motion'
import { valueProps } from '@/components/home/home-data'
import { blockCard } from '@/lib/ui-classes'

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
}

const staggerContainer = {
  initial: {},
  whileInView: { transition: { staggerChildren: 0.1 } },
  viewport: { once: true },
}

export function ValueProposition() {
  return (
    <section className="relative overflow-hidden bg-black px-4 py-24 sm:px-6">
      <div className="absolute left-0 top-0 h-px w-full bg-gradient-to-r from-transparent via-[#07F4F2]/35 to-transparent" />
      <div className="absolute -right-24 top-0 h-72 w-72 rounded-full bg-[#07F4F2]/10 blur-3xl" />
      <div className="absolute -bottom-20 left-0 h-72 w-72 rounded-full bg-[#C1FAB8]/10 blur-3xl" />

      <div className="relative z-10 mx-auto max-w-7xl">
        <motion.div {...fadeIn} className="mx-auto mb-16 max-w-3xl text-center">
          <h2 className="text-3xl font-semibold text-white md:text-5xl">
            以前需要多人协作的流程
            <span className="mt-4 block bg-gradient-to-r from-[#07F4F2] to-[#C1FAB8] bg-clip-text text-transparent">
              现在一个工作台就能完成
            </span>
          </h2>
          <p className="mt-6 text-lg leading-8 text-zinc-400">
            用真实创作模块串起从想法到成片的每一步，把漫剧制作从复杂流程变成可复用的生产能力。
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
          className="grid grid-cols-1 gap-6 md:grid-cols-3"
        >
          {valueProps.map(({ icon: Icon, title, desc }) => (
            <motion.div
              key={title}
              variants={{ initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 } }}
              className={`${blockCard} rounded-3xl p-8 transition-all duration-300 hover:border-[#07F4F2]/30 hover:bg-white/[0.05]`}
            >
              <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-black/35">
                <Icon className="h-8 w-8 text-[#07F4F2]" />
              </div>
              <h3 className="text-2xl font-semibold text-white">{title}</h3>
              <p className="mt-4 text-base leading-7 text-zinc-400">{desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
